export default {"src":"/_next/static/media/close-white.8a483ca3.svg","height":16,"width":16};